module.exports = __webpack_public_path__ + "img/whale.be5030ca.webp";